import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SocketData } from "../../context/SocketContext";

const UserChatHead = ({
  userId,
  unread,
  userName,
  handleSetUnreadMessageCount,
  online,
  profile,
  // unreadMessage,
}) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch({
  //     type: "FIRST_RENDER_CHAT_UNREAD",
  //     payload: { userId, unreadMessage },
  //   });
  // }, [dispatch, userId, unreadMessage]);
  useEffect(() => {
    setUnreadCount(unread);
  }, [unread]);

  return (
    <span
      className={online ? "user_head_details online" : "user_head_details"}
      onClick={() => handleSetUnreadMessageCount(userId)}
      key={userId}
    >
      {profile ? (
        <img
          className="avatar"
          src={`https://drive.google.com/thumbnail?id=${profile}`}
          alt=""
        />
      ) : (
        <span className="avatar">{userName.substr(0, 1)}</span>
      )}

      <span className="user_name">{userName}</span>

      <span className={unreadCount > 0 ? "unread_message_ctr" : ""}>
        {unreadCount > 0 ? `${unreadCount}` : ""}
      </span>
    </span>
  );
};

export default UserChatHead;
